import React from 'react'
import { ReactComponent as CloseIcon } from '../../../assets/icons/close.svg'
import axios from 'axios'
import { useNavigate } from 'react-router-dom'
import OneSignal from 'react-onesignal'
import ModalContainer from '../../common/modal/ModalContainer'

const LogoutModal = ({ onCloseModal }) => {
    const navigate = useNavigate()

    const clearTokens = async () => {
        setTimeout(() => {
            try {
                OneSignal.logout()
            } catch (e) {
                // eslint-disable-next-line no-empty,no-console
                console.log(e)
            }
            localStorage.clear()
            sessionStorage.clear()
            delete axios.defaults.headers.common['Authorization']
            window.location.assign('/login')
        }, 250)
    }

    return (
        <ModalContainer
            className='price-range-modal'
            onCloseModal={() => onCloseModal}
        >
            {' '}
            <div className='common-popup'>
                <div className='common-popup-header d-flex justify-content-between'>
                    <div className='popup-tilte'>
                        <h3 className='semibold-16 mb-0'>Logout</h3>
                    </div>
                    <div
                        className='close-btn cursor-pointer'
                        onClick={onCloseModal}
                    >
                        <CloseIcon />
                    </div>
                </div>

                <div className='common-popup-body p-4'>
                    <div className='space-y-4'>
                        <p className='text-lg black ml-2'>
                            Do you really want to Logout?
                        </p>
                    </div>
                </div>
                <div className='common-popup-footer flex items-center justify-start pb-4'>
                    <button
                        className='button primary'
                        onClick={() => clearTokens()}
                    >
                        Logout
                    </button>
                    <button
                        className='button secondary ml-3'
                        onClick={onCloseModal}
                    >
                        Close
                    </button>
                </div>
            </div>
        </ModalContainer>
    )
}

export default LogoutModal
